<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12">
            <v-toolbar dark color="primary">
              <v-toolbar-title>Login form</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" lazy-validation>
                <v-text-field
                  prepend-icon="mdi-account"
                  label="Login"
                  type="text"
                  v-model="form.username"
                  :rules="rules.required"
                  @keypress.enter.prevent="login()"
                ></v-text-field>
                <v-text-field
                  id="password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  prepend-icon="mdi-lock"
                  label="Password"
                  :type="showPassword ? 'text' : 'password'"
                  v-model="form.password"
                  :rules="rules.required"
                  @click:append="showPassword = !showPassword"
                  @keypress.enter.prevent="login()"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions class="pb-10">
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                class="px-5"
                :disabled="loading"
                @click.prevent="login()"
              >
                <v-progress-circular
                  v-if="loading"
                  indeterminate
                  class="mr-2"
                ></v-progress-circular>
                <span v-if="!loading">Login</span>
                <span v-if="loading">Logging in</span>
              </v-btn>
            </v-card-actions>
            <v-footer> S2S Internet - {{ new Date().getFullYear() }} </v-footer>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <Snackbar></Snackbar>
  </v-main>
</template>

<script>
import Snackbar from "../dialogs/Snackbar.vue";
export default {
  name: "Login",
  components: {
    Snackbar,
  },
  data() {
    return {
      loading: false,
      showPassword: false,
      rules: {
        required: [(value) => !!value || "Required."],
      },
      form: {
        username: "",
        password: "",
      },
    };
  },

  props: {
    source: String,
  },
  methods: {
    login() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.loading = true;
      this.$store
        .dispatch("login", this.form)
        .then((response) => {
          const { adminLogin } = response.data;

          
          const roles = adminLogin.roles.filter((role) => {
            
            return role.code != "api";
          });

          // const subUrl = roles[0].permissions[0].code.split(".").pop();

          
          this.$store.dispatch("addDashboardRole", roles);
          this.$router.push(`/select-dashboard`);
          //console.log("MALI"+roles[0].link +"|"+subUrl)
          // if (
          //   roles[0].link === subUrl ||
          //   roles[0].link === "dashboard" ||
          //   subUrl === "dashboard" ||
          //   subUrl === "home"
          // ) {
          //   this.$router.push(`/${roles[0].link}/`);
          //   this.$store.dispatch("addHomeLink", `/${roles[0].link}/`);
          // } else {
          //   this.$router.push(`/${roles[0].link}/${subUrl}`);
          //   this.$store.dispatch("addHomeLink", `/${roles[0].link}/${subUrl}`);
          // }
          //this.$router.push(`/Distributor`);
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          // this.snachbar.message = err;
          this.$store.dispatch("addSnackbarMessage", err);
          this.$store.dispatch("addSnackbar", true);
        });
    },
  },

  created() {
    //
    // if (this.$store.getters.isLoggedIn) {
    //   return this.$router.push(
    //     `/${this.$store.getters.userRole.toLowerCase()}`
    //   );
    // }
    // // console.log(this.$store.getters.isLoggedIn);

    // this.$store.dispatch("logout");
  },

  computed: {
    userRole() {
      return this.$store.getters.userRole;
    },
  },
};
</script>

<style></style>
